export default __webpack_public_path__ + "static/media/Faturacao-PT.a79d32ec.png";